import { GridRow as FfeRow, type GridRowProps } from "@sb1/ffe-grid-react";
import classNames from "classnames";
import type { FC, RefObject } from "react";

interface Props extends GridRowProps {
	oldColorClass?: string; // TODO: Fjernes etter at alt er over på nytt design
	accentMode?: boolean;
	ref?: RefObject<HTMLDivElement | null>;
}
const GridRow: FC<Props> = ({ oldColorClass, className, accentMode, children, ...rest }) => {
	return (
		<>
			{oldColorClass ? (
				<div className={classNames(oldColorClass, { "ffe-accent-mode": accentMode })}>
					<FfeRow className={classNames(className)} {...rest}>
						{children}
					</FfeRow>
				</div>
			) : (
				<FfeRow className={classNames(className, { "ffe-accent-mode": accentMode })} {...rest}>
					{children}
				</FfeRow>
			)}
		</>
	);
};

export default GridRow;
